import { useState, useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import findFaturamento from '../../service/findFaturamento';
import { SortOrder } from 'primereact/api';
import { Button } from 'primereact/button';
import postRelatorio from '../../service/postRelatorio';
import { FiltrarRelatorio } from '../../interface/FiltrarRelatorio';
import { Messages } from 'primereact/messages';
import putEstornarFaturamento from '../../service/putEstornarFaturamento';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Nullable } from 'primereact/ts-helpers';
import { Toolbar } from 'primereact/toolbar';
import { Tag } from 'primereact/tag';



export default function FaturamentoList() {
  const { t } = useTranslation();
  const [faturamentos, setFaturamentos] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const { state } = useGlobalState();
  const msgs = useRef<Messages>(null);
  const [dataReferencia, setDataReferencia] = useState<Nullable<Date | null>>(null);
  const [status, setStatus] = useState<Nullable<String | null>>(null);

  const statusList = [
    { label: 'Incluído', value: 'INCLUIDO' },
    { label: 'Processado', value: 'PROCESSADO' },
    { label: 'Processando', value: 'PROCESSANDO' },
    { label: 'Estornando', value: 'ESTORNANDO' },
    { label: 'Erro', value: 'ERRO' }
  ]

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    data: dataReferencia,
    status: status,
    idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
    sortField: 'dataReferencia',
    sortOrder: SortOrder.DESC
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: (event.first / event.rows) + 1,
      data: dataReferencia,
      status: status,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };
  const onSort = (event: any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      data: dataReferencia,
      status: status,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder
    });
  };

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const imprimirInconsistencia = (item: any) => {
    const filtrarRelatorio: FiltrarRelatorio = { tipoRelatorio: 'FATURAMENTO_INCONSISTENCIA', tipoArquivo: 'PDF', filtro: { id: item.id } };
    postRelatorio(filtrarRelatorio).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: data, closable: false }

        ]);
      }
    });
  }

  const imprimirEspelho = (item: any) => {
    const filtrarRelatorio: FiltrarRelatorio = { tipoRelatorio: 'FATURAMENTO_ESPELHO', tipoArquivo: 'CSV', filtro: { id: item.id } };
    postRelatorio(filtrarRelatorio).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: data, closable: false }

        ]);
      }
    });
  }

  const estornar = (item: any) => {
    putEstornarFaturamento(item).then((data) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'info', summary: 'Sucesso', detail: data, closable: false }

        ]);
      }
    });
  }

  const actionTemplate = (item: any) => {
    return <>
      {item.status === 'PROCESSADO' && (<Button icon="pi pi-print" type="button" onClick={(e) => { imprimirEspelho(item) }} style={{ background: 'transparent', color: 'gray', border: 'none' }} />)}
      {item.status === 'PROCESSADO' && (<Button icon="pi pi-ban" type="button" onClick={(e) => { imprimirInconsistencia(item) }} style={{ background: 'transparent', color: 'gray', border: 'none' }} />)}
      {item.status === 'PROCESSADO' && (<Button icon="pi pi-trash" type="button" onClick={() => { estornar(item) }} style={{ background: 'transparent', color: 'gray', border: 'none' }} />)}
    </>
  }

  const dateBodyTemplate = (rowData: any, coluna: string) => {
    if (coluna === 'dataFim') {
      return formatDate(rowData.dataFim);
    }
    if (coluna === 'dataInicio') {
      return formatDate(rowData.dataInicio);
    }
    if (coluna === 'dataReferencia') {
      return formatDate(rowData.dataReferencia);
    }

    return formatDate(rowData.dataVencimento);
  };

  const loadLazyData = () => {
    findFaturamento(lazyState).then(data => { setTotalRecords(data.total); setFaturamentos(data.faturamentos) }).catch(() => { setTotalRecords(0); setFaturamentos(undefined) });
  }

  const changeStatus = (stat: Nullable<String>) => {
    if (stat) {
      setStatus(stat);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        data: dataReferencia,
        status: stat,
        idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'dataReferencia',
        sortOrder: SortOrder.DESC
      });
    }
  }

  const statusTemplate = (rowData: any) => {
    return (
      <Tag
        value={getStatusLabel(rowData.status)}
        severity={getStatusSeverity(rowData.status) as any}
      />
    );
  };

  const getStatusSeverity = (status: string) => {
    switch (status) {
      case 'PROCESSADO': return 'success';
      case 'INCLUIDO': return 'secondary';
      case 'PROCESSANDO': return 'info';
      default: return 'info';
    }
  };

  const getStatusLabel = (status: string) => {
    const labels: { [key: string]: string } = {
      'PROCESSADO': 'Processado',
      'INCLUIDO': 'Incluído',
      'PROCESSANDO': 'Processando'
    };
    return labels[status] || status;
  };

  const changeData = (dataRef: Nullable<Date>) => {
    if (dataRef) {
      setDataReferencia(dataRef);
      setlazyState({
        first: 0,
        rows: 10,
        page: 1,
        data: dataRef,
        status: status,
        idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
        sortField: 'dataReferencia',
        sortOrder: SortOrder.DESC
      });
    }
  }

  const startContent = (
    <div className="filtros">
      <div className="filtros-grid">
        <div className="filtros-item">
          <label htmlFor="data" className="font-bold">{t('dataReferencia')}</label>
          <Calendar
            id="data"
            value={dataReferencia}
            onChange={(e) => changeData(e.value)}
            showIcon
            dateFormat="mm/yy"
            locale="pt"
          />
        </div>
        {!state.user.cliente && (
          <div className="filtros-item">
            <label htmlFor="status" className="font-bold">{t("status")}</label>
            <Dropdown inputId="status" value={status} onChange={(e) => { changeStatus(e.value) }} options={statusList} optionLabel="label" placeholder="Selecione Status"
              showClear filter />
          </div>
        )}
      </div>
    </div>
  );

  useEffect(() => {
    loadLazyData();
  }, [lazyState])

  return (
    <div>
      <Messages ref={msgs} />
      <div>
        <Toolbar start={startContent} />
        <br></br>
        <br></br>
        <DataTable value={faturamentos} first={lazyState.first} dataKey="id" paginator={true} lazy={true}
          emptyMessage="Sem registros"
          onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
          rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
          tableStyle={{ minWidth: '75rem' }}>
          <Column field='dataInclusao' sortable header={t('dtInclusao')} />
          <Column field='status' header={t('status')} body={statusTemplate} />
          <Column body={(e) => dateBodyTemplate(e, 'dataReferencia')} header={t('dataReferencia')} />
          <Column body={(e) => dateBodyTemplate(e, 'dataVencimento')} header={t('dataVencimento')} />
          <Column body={(e) => dateBodyTemplate(e, 'dataInicio')} header={t('dataInicio')} />
          <Column body={(e) => dateBodyTemplate(e, 'dataFim')} header={t('dataFim')} />
          <Column body={actionTemplate} />
        </DataTable>
      </div>
    </div>
  )
}


